import React from 'react';
import { useTranslation } from 'react-i18next';

function YearCombo(props) {

    const { t } = useTranslation();
    const thisYear = new Date().getFullYear();
    const { handleYearChange, startYear, year } = props;

    let options = [<option key="all" value="all">{t('common:options.year.all')}</option>];
    for (let year=thisYear;year>=startYear;year--) {
        options.push(<option key={year} value={year}>{year}</option>);
    }
    
    return (            
        <select onChange={handleYearChange} value={year} className="default_select">
            {options}
        </select>
    );
}

export default YearCombo;